import UnderConstruction from "../common/UnderConstruction";

export default function InventoryIssue() {
  return <UnderConstruction title="Issue Register" />;
}
